import Call from "assets/call.svg";
import Download from "assets/download.svg";
import Locator from "assets/locator.svg";
import Steer from "assets/steer.svg";
import { useLanguage } from "LanguageContext";
import Broucher from "Pages/components/Broucher";
import Enquire from "Pages/Enquire/Enquire";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "ReusableComponents/Box";
import { WEIGHT } from "theme";
import { TextStyled } from "ReusableComponents/Text/styles";
import { useSelector, useDispatch } from "react-redux";
import { openEnquiry } from "store/actions/enquiryActions";

const Banner = ({ small, medium }) => {
  const { t } = useTranslation();
  const { selectedLanguage } = useLanguage();
  const dispatch = useDispatch();

  const [brochureOpen, setBrochureOpen] = useState(false);
  const enquireOpen = useSelector((state) => state.Enquiry.isOpen);
  const [currentIndex, setCurrentIndex] = useState(0);
  const slideIntervalRef = useRef(null);

  const boxes = [
    {
      label: "Charging Hub Locator",
      image: Locator,
      link: "/charging-network",
      show: true,
    },
    {
      label: "Call Us 1800 1238 1238",
      image: Call,
      link: "tel:1800 1238 1238",
      show: true,
    },
    {
      label: "Enquire Now",
      image: Download,
      action: () => dispatch(openEnquiry()),
      show: !enquireOpen,
    },
    {
      label: "Book a Test Ride",
      image: Steer,
      action: () => (window.location.href = `/${selectedLanguage}/test-ride`),
      show: true,
    },
    {
      label: "Download Brochure",
      image: Download,
      action: () => setBrochureOpen(true),
      show: true,
    },
  ];

  // split out the Enquire button vs everything else to rotate
  const enquireBox = boxes.find((b) => b.label === "Enquire Now");
  const rotateBoxes = boxes.filter((b) => b.show && b.label !== "Enquire Now");

  // carousel
  useEffect(() => {
    startSlide();
    return stopSlide;
  }, []);

  const startSlide = () => {
    stopSlide();
    const len = rotateBoxes.length;
    slideIntervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % len);
    }, 5000);
  };
  const stopSlide = () => {
    clearInterval(slideIntervalRef.current);
  };

  const renderBox = (box) => {
    if (!box || !box.show) return null;
    const onClick = () => {
      if (box.action) box.action();
      else if (box.link) {
        window.location.href = box.link.startsWith("tel:")
          ? box.link
          : `/${selectedLanguage}${box.link}`;
      }
    };
    return (
      <Box
        display="flex"
        alignItems="center"
        cursor="pointer"
        onClick={onClick}
        padding={small || medium ? "8px 16px" : "8px 12px"}
        borderRadius="8px"
        transition="all 0.2s ease"
        _hover={{
          background: "rgba(255,255,255,0.1)",
          transform: "translateY(-2px)",
        }}
      >
        <img
          src={box.image}
          alt={box.label}
          style={{
            marginRight: 8,
            width: small || medium ? 20 : 24,
            height: small || medium ? 20 : 24,
          }}
        />
        <TextStyled
          fontSize={small || medium ? 14 : 16}
          margin="0"
          fontWeight={WEIGHT.bold}
          color="#000"
        >
          {t(box.label)}
        </TextStyled>
      </Box>
    );
  };

  return (
    <>
      <Box
        h={small || medium ? "64px" : "56px"}
        padding="0 20px"
        display="flex"
        alignItems="center"
        justifyContent={small || medium ? "flex-start" : "space-between"}
        position="fixed"
        left="0"
        right="0"
        bottom="0"
        zIndex="12"
        background="#9CCDFB"
        boxShadow="0 -2px 10px rgba(0,0,0,0.1)"
      >
        {small || medium ? (
          <>
            {/* left – always show Enquire when form closed */}
            <Box mr={2}>{renderBox(enquireBox)}</Box>

            {/* right – carousel of all the others */}
            <Box
              flex="1"
              display="flex"
              justifyContent="center"
              position="relative"
            >
              {renderBox(rotateBoxes[currentIndex])}

              {/* indicators */}
              <Box
                position="absolute"
                bottom={-8}
                left="50%"
                transform="translateX(-50%)"
                display="flex"
                gap="4px"
              >
                {rotateBoxes.map((_, idx) => (
                  <Box
                    key={idx}
                    width="6px"
                    height="6px"
                    borderRadius="50%"
                    background={
                      idx === currentIndex ? "#000" : "rgba(0,0,0,0.3)"
                    }
                    transition="all 0.2s ease"
                  />
                ))}
              </Box>
            </Box>
          </>
        ) : (
          // desktop
          boxes.map((b, i) => (
            <React.Fragment key={i}>{renderBox(b)}</React.Fragment>
          ))
        )}
      </Box>

      {/* Brochure */}
      {brochureOpen && (
        <Broucher
          open={brochureOpen}
          small={small}
          medium={medium}
          handleClose={() => setBrochureOpen(false)}
        />
      )}

      {/* Enquire Form */}
      {enquireOpen && (
        <Enquire open={enquireOpen} small={small} medium={medium} />
      )}
    </>
  );
};

export default Banner;
